import React from 'react';
import { useHomeProducts } from '../useHomeProducts';
import { HomeProductsSlider } from '../components/HomeProductsSlider';
export const HomeProductsSliderContainer = () => {
    const homeProducts = useHomeProducts();
    if (!homeProducts)
        return null;
    return (React.createElement(HomeProductsSlider, { key: homeProducts.categories ? homeProducts.categories.value : null, categories: homeProducts.categories, products: homeProducts.products, onProductClick: homeProducts.onProductClick }));
};
